//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      default: '提交'
    },
    loading: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    jump () {
      if (this.loading) {
        return
      }
      if (this.hidden) {
        return
      }
      this.$emit('click')
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiBottom.vue